'use strict';
import firebase from 'firebase/app';
import 'firebase/auth';

export default function getHeader(token = null) {
	return new Promise(async (resolve, reject) => {
		if (token == null) {
			// Check if there is a current user
			const currentUser = firebase.auth().currentUser;
			if (currentUser) {
				// Get the token and refresh it if it has expired
				token = await currentUser.getIdToken(true);
			} else {
				// No user is authenticated
				reject(new Error('No authenticated user'));
				return;
			}
		}

		resolve ({
			'headers': {
				"Authorization": "Bearer " + token
			}
		})
	})
 }